module.exports = __webpack_public_path__ + "media/3dmaxplugin2.9b8fe665.mp4";